
import React from "react";
import { FileUploader } from "react-drag-drop-files";
import Compressor from 'compressorjs';

const FileUpload: React.FC<{ csv?: boolean, excel?: boolean, document?: boolean, multiple?: boolean, handleFileUpload: any, allowedFileTypes?: string[], onError?: (message: string) => void, maxSizeMb?: number, typeErrorMessage?: string }> = ({
  csv,
  excel,
  document,
  multiple,
  handleFileUpload,
  allowedFileTypes = ["JPG", "PNG", "GIF", "JPEG"],
  onError,
  maxSizeMb = 20,
  typeErrorMessage
}) => {

  const handleCompressedUpload = (e: any) => {
    // `document` (bills) opts out of compression for the same reason csv/excel do: the file is
    // uploaded for machine reading, and re-encoding a scanned bill would degrade the very text
    // extraction is trying to read. With `multiple`, react-drag-drop-files hands back a FileList
    // rather than a File, which Compressor cannot take at all.
    if (csv || excel || document || multiple) {
      handleFileUpload(e)
    } else {
      const file: File = e;
      const isImage = file && file.type && file.type.startsWith('image/');
      if (!isImage) {
        handleFileUpload(file);
        return;
      }
      new Compressor(file, {
        maxWidth: 1600,
        quality: 0.8,
        success: (compressedResult) => {
          handleFileUpload(compressedResult);
        },
      });
    }

  };
  return (
    <FileUploader
      sx={{ width: '100%' }}
      handleChange={(event: any) => handleCompressedUpload(event)}
      name="file"
      multiple={multiple}
      types={allowedFileTypes}
      classes='file-upload'
      maxSize={maxSizeMb}
      onSizeError={() => onError && onError(`File is too large. Maximum size is ${maxSizeMb}MB.`)}
      onTypeError={() => onError && onError(typeErrorMessage || 'Unsupported file type. Please upload a CSV or Excel file.')}
    />
  );
}

export default FileUpload;